<template>
<b-row>
   <b-col cols="12" xl="12"> 
      <b-card>
        <b-form @submit.prevent="roleAdd">
          <b-row>
            <b-col>
                <b-form-group label="*Role Name:" label-for="rolename">
                    <b-form-input maxlength="40" :class="{ 'is-invalid' : $v.form.rolename.$error }" id="rolenameField" v-model="$v.form.rolename.$model" type="text" class="form-control" placeholder="Enter Role  Name"  aria-describedby="rolenameField" />
                    <b-form-invalid-feedback id="rolenameField">
                      This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col>
                <b-form-group label="*Role Weight:" label-for="roleWeightField">
                    <b-form-input min="0" max="100"  maxlength="2" :class="{ 'is-invalid' : $v.form.roleweight.$error }" id="roleWeightField" v-model="$v.form.roleweight.$model" type="text" class="form-control" placeholder="Enter Role Weight"  aria-describedby="roleWeightField" />
                    <b-form-invalid-feedback id="roleWeightField" v-if="!$v.form.roleweight.required">
                       This is a required field
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback id="roleWeightField" v-if="!$v.form.roleweight.numeric">
                      Numeric value only
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-button type="button" v-b-tooltip.hover title="Cancel" variant="secondary" @click.stop="gotolist()"  class="px-4">Cancel</b-button>
              <b-button type="submit" v-b-tooltip.hover title="Save" variant="primary"  class="px-4 pull-right">Save</b-button> 
            </b-col>
          </b-row>
        </b-form>
      </b-card>
  </b-col>
</b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'  
import { validationMixin } from 'vuelidate';  
import { required, maxLength, numeric } from 'vuelidate/lib/validators';
import { getResponseMessages } from '../../_helpers';
export default {
  name: 'Role_Add',
  data() {
    return {
      form: {
        rolename:'',
        roleweight:0
      }
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
      rolename: {
        required,
        maxLength: maxLength(40)
      },
      roleweight: {
        required,
        numeric,
        maxLength: maxLength(2)
      }
    }  
  },
  created(){
    if(this.$route.params.id != undefined){
      this.getRoleById(this.$route.params.id)
    }
  },  
  methods: {
     ...mapActions('org', ['getById','saveData']),
    roleAdd() {
      this.$v.form.$touch();
      if(this.$v.form.$error) return
      this.$store.dispatch('saveData',{url:'role/saveRole',data: this.form}).then((res) => { 
        this.$toastr('success', getResponseMessages(res.data.messages), 'Success')
        this.$router.push('/role')
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    gotolist () {
        this.$router.push('/role/list')
    },
    getRoleById(id) {
      this.$store.dispatch('getById', {url:'role/getRoleById',data : { 'roleIndex':id }}).then((res) => {
        this.form = Object.assign({}, res)  
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    }
  }
}
</script>
